module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "pagevii"
    }
  }), _vm._v("Illustrations")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter"
  }, [_c('em', [_vm._v("Between pages 128 and 129")])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter5#ill1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25th Dragoons begin bunker-busting in the Arakan")])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter5#ill2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Close quarter action at Hill 1070")])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter5#ill3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B Squadron 3rd Carabiniers and 1st Dogras begin to climb Nunshigum")])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter5#ill4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("British infantry, supported by Lees, clear a village during the Imphal battle")])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter5#ill5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An historic meeting")])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter5#ill6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Waiting to cross. A troop of 7th Light Cavalry preparing to cross the Irrawaddy")])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter5#ill7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Carabinier Lee comes ashore in 2nd Division’s bridgehead")])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter5#ill8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("On the road to Mandalay")])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter5#ill9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tanks of 150 Regiment RAC, with Mandalay hill")])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter5#ill10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Sherman of the Royal Deccan Horse in action at Yewe")])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter5#ill11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Carabiniers support an infantry attack")])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter5#ill12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The dash to Rangoon")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2757509c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/06_illustrations.vue
// module id = 72
// module chunks = 0